import WithDefaultOptionHelper from "../WithDefaultOptionHelper";

const options = [
  { key: "180", value: "180", text: "clientPanelConstants:slowest" },
  { key: "120", value: "120", text: "clientPanelConstants:slow" },
  { key: "90", value: "90", text: "clientPanelConstants:medium" },
  { key: "60", value: "60", text: "clientPanelConstants:fast" },
  { key: "30", value: "30", text: "clientPanelConstants:fastest" },
];

export default WithDefaultOptionHelper(options);
